/**
 * 一个空的方法，始终返回 undefined，可用于初始化值
 */
function noop () {}

module.exports = noop



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/function/noop.js
// module id = 6tF0
// module chunks = 125